import Swal from "sweetalert2";

export const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary btn-round buttons",
    cancelButton: "btn btn-secondary btn-round buttons"
  },
  buttonsStyling: false
});
